<template>
  <el-submenu v-if="item.children.length" :index="String(item.id)">
    <template slot="title"><i :class="item.icon || 'el-icon-folder'" /><span>{{ item.name }}</span></template>
    <authorized-menu v-for="child in item.children" :key="child.id" :item="child" />
  </el-submenu>
  <el-menu-item v-else :index="item.path"><i :class="item.icon || 'el-icon-menu'" /><span slot="title">{{ item.name }}</span></el-menu-item>
</template>

<script>
export default { name: 'AuthorizedMenu', props: { item: { type: Object, required: true } } }
</script>
